var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.2891C11.349 16.2891 11.2083 16.224 11.0781 16.0938L5.15625 9.85938C5.10417 9.80729 5.0625 9.75 5.03125 9.6875C5.00521 9.625 4.99219 9.55469 4.99219 9.47656C4.99219 9.3776 5.01562 9.28646 5.0625 9.20312C5.10938 9.11979 5.17188 9.05469 5.25 9.00781C5.33333 8.96094 5.42448 8.9375 5.52344 8.9375C5.67969 8.9375 5.80729 8.98958 5.90625 9.09375L11.8438 15.3281H11.1562L17.0859 9.09375C17.1953 8.98958 17.3229 8.9375 17.4688 8.9375C17.5729 8.9375 17.6641 8.96094 17.7422 9.00781C17.8203 9.05469 17.8828 9.11979 17.9297 9.20312C17.9818 9.28646 18.0078 9.3776 18.0078 9.47656C18.0078 9.61719 17.9531 9.74219 17.8438 9.85156L11.9219 16.0938C11.8646 16.1562 11.7995 16.2057 11.7266 16.2422C11.6536 16.2734 11.5781 16.2891 11.5 16.2891Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.c0176ca3.svg";
export { ForwardRef as ReactComponent };